import type { FormValues } from '../../../../common/types';
import { CALENDAR_NAME, TIMEZONE } from '../../../../common/ui/constants.tsx';
import type { SaveCalendarRequest, Context } from '../../../../services/save-calendar/types.tsx';
import { getWorkingTimes, getHolidays } from './utils';

export const getSaveRequestPayload = (
	idCurrent: number | null | undefined,
	context: Context,
	formData: FormValues,
	isCopied: boolean,
): SaveCalendarRequest => {
	// @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'number | undefined'.
	const id: number | typeof undefined = isCopied ? undefined : idCurrent; // If it is copied from other service desk projects, do not use the id of the other project calendar
	const formKeys = Object.keys(formData);
	const name = formData[CALENDAR_NAME];
	const timezoneId = formData[TIMEZONE].value;
	const workingTimes = getWorkingTimes(formKeys, formData);
	const holidays = getHolidays(formKeys, formData);

	return {
		id,
		context,
		name,
		timezoneId,
		workingTimes,
		holidays,
	};
};
